import { MouseEvent, ReactNode } from "react";
import "./compact-button.scss";

type CompactButtonProps = {
	children?: string;
	onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
	type?: "button" | "submit" | "reset";
	unactive?: boolean;
	className?: string;
	iconLeft?: ReactNode;
	iconRight?: ReactNode;
	theme?: string; // default/red/green
	title?: string;
};

export const CompactButton = ({
	children,
	onClick,
	type = "button",
	unactive = false,
	className = "", // small - уменьшаем высоту
	iconLeft,
	iconRight,
	theme,
	title,
}: CompactButtonProps) => {
	return (
		<button
			type={type}
			onClick={onClick}
			disabled={unactive}
			title={title}
			className={`compact-button${unactive ? " compact-button--unactive" : ""}${theme ? ` ${theme}` : ""}${className ? ` ${className}` : ""}`}>
			{iconLeft && (
				<span className='compact-button__icon compact-button__icon--left'>
					{iconLeft}
				</span>
			)}
			<span className='compact-button__label'>{children}</span>
			{iconRight && (
				<span className='compact-button__icon compact-button__icon--right'>
					{iconRight}
				</span>
			)}
		</button>
	);
};
